import { useQuery } from '@tanstack/react-query';

// Define the expected response structure
export interface TimeApiResponse {
  abbreviation: string;
  client_ip: string;
  datetime: string;
  day_of_week: number;
  day_of_year: number;
  dst: boolean;
  dst_from: string | null;
  dst_offset: number;
  dst_until: string | null;
  raw_offset: number;
  timezone: string;
  unixtime: number;
  utc_datetime: string;
  utc_offset: string;
  week_number: number;
}

export const timeApiData = {} as TimeApiResponse;
// Function to fetch and return the data from the API
export async function getTimeApiData(): Promise<TimeApiResponse> {
  try {
    const response = await fetch('https://worldtimeapi.org/api/ip');
    if (!response.ok) {
      console.warn('failed to fetch time api data... it is ok, don\'t freak out...')
      return {}
    }

    const data: TimeApiResponse = await response.json();
    return data;
  } catch (e) {
    return {}
  }

}

export const useTimeApiData = () =>
  useQuery({
    queryKey: ['timeApiData'],
    queryFn: getTimeApiData,
    enabled: false,
  });
